import { FC } from "react";
import { SearchSortBlock } from "../SearchSortBlock";
import { EApproveStatus, TSortState } from "../../types";
import { SeriesCard } from "../SeriesCard/SeriesCard";
import { StyledCardWrapper } from "./styled";

interface IProps {
  search: string;
  sections: {
    key: string;
    title: string;
    status: EApproveStatus;
    date: string;
    sectionId: string;
    text: string;
  }[];
  handleSearch: (value: string) => void;
}

export const SeriesTab: FC<IProps> = ({ search, sections, handleSearch }) => {
  return (
    <>
      <SearchSortBlock
        search={search}
        sortArray={["дата изменения РД", "название"]}
        currentSort={{ direction: "asc", sort: "дата изменения РД" }}
        handleSearch={handleSearch}
        changeSort={({ sort, direction }: TSortState) => {}}
      />
      <StyledCardWrapper>
        {sections.map((item) => (
          <SeriesCard
            key={item.key}
            to={item.sectionId}
            title={item.title}
            date={item.date}
            status={item.status}
            text={item.text}
          />
        ))}
      </StyledCardWrapper>
    </>
  );
};
